import { User } from '@tamagui/lucide-icons';
import { useProfileGetQuery } from '@unistocks/proxy/axios-client/ProfileQuery';
import { AvatarProps, Avatar as TMAvatar } from 'tamagui';

export const Avatar: React.FC<AvatarProps> = props => {
  const { data: profile } = useProfileGetQuery();

  return (
    <TMAvatar circular cursor="pointer" {...props}>
      <TMAvatar.Image
        accessibilityLabel={`${profile?.name ?? ''} ${profile?.surname ?? ''}`}
        src={profile?.extraProperties.ProfilePictureUrl}
      />
      <TMAvatar.Fallback
        delayMs={150}
        backgroundColor={'$color4'}
        justifyContent="center"
        alignItems="center"
      >
        <User color={'$unistocks'} />
      </TMAvatar.Fallback>
    </TMAvatar>
  );
};
